// Hlavná kompozícia stránky – poradie sekcií môžeš ľubovoľne meniť.
import React from 'react';
import './App.css';

import useAvailability from './hooks/useAvailability';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Stats from './components/Stats';
import Pitch from './components/Pitch';
import Vehicle from './components/Vehicle';
import Gallery from './components/Gallery';
import Pricing from './components/Pricing';
import HowItWorks from './components/HowItWorks';
import BookingSection from './components/BookingSection';
import AudienceFit from './components/AudienceFit';
// Dočasne vypnuté sekcie – na opätovné zapnutie odkomentuj import aj použitie nižšie.
// import RoutePlanner from './components/RoutePlanner';
// import TripInspiration from './components/TripInspiration';
import Reviews from './components/Reviews';
import Faq from './components/Faq';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingCta from './components/FloatingCta';

function App() {
  const { occupiedSet, status, nextAvailableKey, bookedNightsThisSeason } = useAvailability();

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero nextAvailableKey={nextAvailableKey} />
        <Stats bookedNights={bookedNightsThisSeason} />
        <Pitch />
        <Vehicle />
        <Gallery />
        <Pricing />
        <HowItWorks />
        <BookingSection occupiedSet={occupiedSet} status={status} />
        <AudienceFit />
        {/* <RoutePlanner /> */}
        {/* <TripInspiration /> */}
        <Reviews />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <FloatingCta />
    </div>
  );
}

export default App;
